<template>
  <div>
    <!-- pc -->
    <div class="normal">
      <div class="header">
        <div class="top_row1">
          <div class="logo">
            <a href="https://ggzyjy.nmg.gov.cn/" target="_blank">
              <!-- <img src="../../assets/img/logo20210202.png" alt="" style="border-style: none"/> -->
              <img  src="../../assets/img/ggzy_logo.png" alt="" style="border-style: none;">
            </a>
          </div>
          <!-- 搜索位置 -->
          <el-dialog
            id="nmgsitechange"
            title="站点切换"
            :visible.sync="selectPosition"
            width="1065px"
            style="border-radius:10px"
          >
            <img src="../../assets/img/flomodel0203.png" class="flomodel">
            <div class="selectPositionArea">
              <div class="searchAll">
                <div class="fl qpt" style="width: 7%">全平台：</div>
                <div class="fr" style="width: 93%">
                  <div class="aPosition">
                    <span
                      :class="{ active_position: searchPosition == '全平台' }"
                      @click="changePosition('全平台', 0)"
                      >自治区本级</span
                    >
                  </div>
                </div>
              </div>
              <div class="searchLocal">
                <div class="fl bz" style="width: 7%">本<span>站：</span></div>
                <div class="fr" style="width: 93%">
                  <div class="aPosition">
                    <span
                      :class="{ active_position: searchPosition == '本站' }"
                      @click="changePosition('本站', 39)"
                      >内蒙古自治区公共资源交易网</span
                    >
                  </div>
                </div>
              </div>
              <div class="searchCity">
                <div class="fl bm" style="width: 7%">部<span>门：</span></div>
                <div class="fr" style="width: 93%">
                  <div
                    class="aPosition fl"
                    v-for="(item, index) in sites"
                    :key="index"
                    style="margin-right: 35px"
                  >
                    <!-- <a
                      :href="
                        item.indexLogHref +
                        '/nmg_dept_search/#/Door?keywords=&siteTag=1&siteid=' +
                        item.siteId
                      "
                      target="_blank"
                      v-html="item.titleName.substring(3,item.titleName.length)">
                    </a> -->
                    <a
                      :href="item.searchAddress"
                      target="_blank"
                      v-html="item.titleName.substring(3,item.titleName.length)">
                    </a>
                  </div>
                </div>
              </div>
            </div>
            
          </el-dialog>
          <!-- 顶部搜索栏 -->
          <div class="normalSearchBar">
            <div class="searchPosition fl" @click="selectPosition = true">
              {{ searchPosition }}
            </div>
            <div>
              <input
                type="text"
                name=""
                placeholder="请输入关键字查询"
                v-model="search"
                class="searchInput"
                @input="changeKey"
                @keyup.enter="btn_seach"
                maxlength="50"
              />
              <input type="button" value="搜索" @click="btn_seach" />
            </div>
            <div class="clear"></div>
            <!-- <div class="hotWords" v-show="!isOnFocus">
              热搜词:
              <span style="margin-left: 10px" @click="btn_hotWord($event)"
                >复工复产</span
              >
              <span @click="btn_hotWord($event)">疫情防控</span>
              <span @click="btn_hotWord($event)">生态环境</span>
              <span @click="btn_hotWord($event)">旅游</span>
            </div> -->
            <div class="hotWords" v-show="!isOnFocus" style="height:25px;overflow:hidden">
              <div style="float:left">热搜词：</div>
              <span style="float:left;display:block" v-for="(item, index) in hotwords.slice(0,5)" :key="index" @click="btn_hotWord(item.name)"
                >{{item.name}}</span
              >
            </div>
            <div class="showList" v-show="isOnFocus">
              <div
                class="row"
                v-for="(item, index) in tips"
                :key="index"
                @click="click_tip($event)"
              >
                {{ item }}
              </div>
              <!-- <div class="row2">
                <div style="width: 510px; border-top: 1px solid grey">
                  <div class="tag fl">
                    <img
                      src="../../assets/img/normal_search/ZhiNengZhuShou.png"
                      alt=""
                    />
                  </div>
                  <div class="fl" style="margin-right: 38px">
                    您也可以使用智能助手找到结果
                  </div>
                  <div class="fl" style="color: rgb(225, 117, 116)">
                    找智能助手<span>></span>
                  </div>
                </div>
              </div> -->
            </div>
          </div>

          <!-- 高级搜索
         -->
          <div class="highArea fl">
            <div class="row1" @click="btn_highSearch">
              <span>高级检索</span><i></i>
            </div>
            <!-- <div class="row2" @click="btn_policySearch"><i></i>政策文件搜索</div> -->
          </div>
        </div>
      </div>
      <div class="clear"></div>

      

      <div class="main">


        <div class="nav">
        <div class="navs">
          <div
            class="aNav"
            :class="{ active: isActive == '门户网站' }"
            @click="btn_nav($event)"
          >
            <img class="huawen" src="../../assets/img/huawen.png">
            <router-link :to="{ name: 'door', query: { keywords: search } }"
              >门户网站</router-link
            >
            <img class="sanjiao" src="../../assets/img/sanjiao.png" >
          </div>
          <div
            class="aNav"
            :class="{ active: isActive == '政策' }"
            @click="btn_nav($event)"
          >
          <img class="huawen" src="../../assets/img/huawen.png">
            
            <router-link :to="{ name: 'policy', 
              query: { 
                keywords: search,
                isSearchRmzfAndBgt:''
              } 
              
              }"
              >政策</router-link
            >
            <img class="sanjiao" src="../../assets/img/sanjiao.png" >
          </div>
          
          <div
            class="aNav"
            :class="{ active: isActive == '交易信息' }"
            @click="btn_nav($event)"
          >
           <img class="huawen" src="../../assets/img/huawen.png">
            <router-link :to="{ name: 'work', query: { keywords: search } }"
              >交易信息</router-link
            >
            <img class="sanjiao" src="../../assets/img/sanjiao.png" >
          </div>
          <div
            class="aNav"
            :class="{ active: isActive == '公开' }"
            @click="btn_nav($event)"
          >
          <img class="huawen" src="../../assets/img/huawen.png">
            <router-link
              :to="{
                name: 'open',
                query: {
                  keywords: search,
                  isZC: '',
                  highChange: true,
                  publisher: '',
                  lanmu: '',
                  docno: '',
                  startTime: '',
                  endTime: '',
                  gbtag: '',
                },
              }"
              >公开</router-link
            >
            <img class="sanjiao" src="../../assets/img/sanjiao.png" >
          </div>
          <div
            class="aNav"
            :class="{ active: isActive == '要闻' }"
            @click="btn_nav($event)"
          >
          <img class="huawen" src="../../assets/img/huawen.png">
            <router-link :to="{ name: 'news', query: { keywords: search } }"
              >要闻</router-link
            >
            <img class="sanjiao" src="../../assets/img/sanjiao.png" >
          </div>
          <div
            class="aNav"
            :class="{ active: isActive == '互动' }"
            @click="btn_nav($event)"
          >
          <img class="huawen" src="../../assets/img/huawen.png">
            <router-link
              :to="{ name: 'interact', query: { keywords: search } }"
              @click="btn_nav($event)"
              >互动</router-link
            >
            <img class="sanjiao" src="../../assets/img/sanjiao.png" >
          </div>
          <!-- <div
            class="aNav"
            :class="{ active: isActive == '爱上内蒙古' }"
            @click="btn_nav($event)"
          >
          <img class="huawen" src="../../assets/img/huawen.png">
            <router-link :to="{ name: 'enter', query: { keywords: search } }"
              >爱上内蒙古</router-link
            >
            <img class="sanjiao" src="../../assets/img/sanjiao.png" >
          </div> -->
          <!-- <div
            class="aNav"
            style="
              
              margin-right: 0px;
              color: rgb(77, 143, 191);
            "
          >
            |
          </div>
          <div class="aNav" :class="{ active: isActive == '公报' }" @click="btn_nav($event)">
            <img class="huawen" src="../../assets/img/huawen.png">
            <router-link :to="{
                          name: 'gb',
                          query: {
                            keywords: search,
                            isZC: '',
                            highChange: true,
                            publisher: '',
                            lanmu: '',
                            docno: '',
                            startTime: '',
                            endTime: '',
                            gbtag: 'true',
                          },
                        }">公报</router-link>
            <img class="sanjiao" src="../../assets/img/sanjiao.png">
          </div>
          <div
            class="aNav"
            :class="{ active: isActive == '微信' }"
            @click="btn_nav($event)"
          >
          <img class="huawen" src="../../assets/img/huawen.png">
            <router-link :to="{ name: 'wechat', query: { keywords: search } }"
              >微信</router-link
            >
            <img class="sanjiao" src="../../assets/img/sanjiao.png" >
          </div>
          <div
            class="aNav"
            :class="{ active: isActive == '图片' }"
            @click="btn_nav($event)"
          >
          <img class="huawen" src="../../assets/img/huawen.png">
            <router-link :to="{ name: 'pic', query: { keywords: search } }"
              >图片</router-link
            >
            <img class="sanjiao" src="../../assets/img/sanjiao.png" >
          </div>
          <div
            class="aNav"
            :class="{ active: isActive == '视频' }"
            @click="btn_nav($event)"
          >
          <img class="huawen" src="../../assets/img/huawen.png">
            <router-link :to="{ name: 'video', query: { keywords: search } }"
              >视频</router-link
            >
            <img class="sanjiao" src="../../assets/img/sanjiao.png" >
          </div>
          <div
            class="aNav"
            style="
              
              margin-right: 15px;
              color: rgb(77, 143, 191);
            "
          >
            |
          </div>
          
          <div
            class="aNav"
            :class="{ active: isActive == '盟市' }"
            @click="btn_nav($event)"
          >
          <img class="huawen" src="../../assets/img/huawen.png">
            <router-link :to="{ name: 'city', query: { keywords: search } }"
              >盟市</router-link
            >
            <img class="sanjiao" src="../../assets/img/sanjiao.png" >
          </div> -->
          <!-- <div class="aNav" style="margin-left: 40px; color: rgb(77, 143, 191)">
            |
          </div> -->
          <!-- 
          <div
            class="aNav"
            :class="{ active: isActive == '部门' }"
            style="cursor: default"
          >
            部门
          </div>
          <div
            class="aNav"
            :class="{ active: isActive == '盟市' }"
            style="cursor: default"
          >
            盟市
          </div>
          <div
            class="aNav"
            :class="{ active: isActive == '自治区站群' }"
            style="margin-right: 0; cursor: default"
          >
            自治区站群
          </div> -->
        </div>
      </div>
      <div class="clear"></div>




        <router-view
          ref="child"
          v-if="update"
          @rfunc="getSearchKey"
          @rhighSearch="getHighSearch"
          @rIsActice="getIsActice"
          :cSiteID="siteID"
        ></router-view>
      </div>
      <div class="clear"></div>
      <div class="footer">
        <v-footer></v-footer>
      </div>
    </div>
    <!-- 移动端 -->
    <div class="mobile" v-if="mobile">
      <div class="topBar">
        <div class="loginArea">
          <div class="menu" @click="drawer = true"></div>
          <el-drawer
            :visible.sync="drawer"
            :direction="direction"
            :with-header="false"
            size="50%"
          >
            <div class="navs">
              <div
                class="aNav"
                :class="{ active: isActive == '门户网站' }"
                @click="btn_nav($event)"
              >
                <router-link :to="{ name: 'door', query: { keywords: search } }"
                  >门户网站</router-link
                >
              </div>
              <div
                class="aNav"
                :class="{ active: isActive == '政策' }"
                @click="btn_nav($event)"
              >
                <router-link
                  :to="{ name: 'policy', query: { keywords: search } }"
                  >政策</router-link
                >
              </div>
              <!-- <div
                class="aNav"
                :class="{ active: isActive == '公报' }"
                @click="btn_nav($event)"
              >
                <router-link
                  :to="{
                    name: 'gb',
                    query: {
                      keywords: search,
                      isZC: '',
                      highChange: true,
                      publisher: '',
                      lanmu: '',
                      docno: '',
                      startTime: '',
                      endTime: '',
                      gbtag: 'true',
                    },
                  }"
                  >公报</router-link
                >
              </div> -->
              <div
                class="aNav"
                :class="{ active: isActive == '交易信息' }"
                @click="btn_nav($event)"
              >
                <router-link :to="{ name: 'work', query: { keywords: search } }"
                  >交易信息</router-link
                >
              </div>
              <div
                class="aNav"
                :class="{ active: isActive == '公开' }"
                @click="btn_nav($event)"
              >
                <router-link
                  :to="{
                    name: 'open',
                    query: {
                      keywords: search,
                      isZC: '',
                      highChange: true,
                      publisher: '',
                      lanmu: '',
                      docno: '',
                      startTime: '',
                      endTime: '',
                      gbtag: '',
                    },
                  }"
                  >公开</router-link
                >
              </div>
              <div
                class="aNav"
                :class="{ active: isActive == '要闻' }"
                @click="btn_nav($event)"
              >
                <router-link :to="{ name: 'news', query: { keywords: search } }"
                  >要闻</router-link
                >
              </div>
              <div
                class="aNav"
                :class="{ active: isActive == '互动' }"
                @click="btn_nav($event)"
              >
                <router-link
                  :to="{ name: 'interact', query: { keywords: search } }"
                  @click="btn_nav($event)"
                  >互动</router-link
                >
              </div>
              <!-- <div
                class="aNav"
                :class="{ active: isActive == '爱上内蒙古' }"
                @click="btn_nav($event)"
              >
                <router-link
                  :to="{ name: 'enter', query: { keywords: search } }"
                  >爱上内蒙古</router-link
                >
              </div> -->
              <!-- <div
                class="aNav"
                :class="{ active: isActive == '微信' }"
                @click="btn_nav($event)"
              >
                <router-link
                  :to="{ name: 'wechat', query: { keywords: search } }"
                  >微信</router-link
                >
              </div>
              <div
                class="aNav"
                :class="{ active: isActive == '图片' }"
                @click="btn_nav($event)"
              >
                <router-link :to="{ name: 'pic', query: { keywords: search } }"
                  >图片</router-link
                >
              </div>
              <div
                class="aNav"
                :class="{ active: isActive == '盟市' }"
                @click="btn_nav($event)"
              >
                <router-link :to="{ name: 'city', query: { keywords: search } }"
                  >盟市</router-link
                >
              </div> -->
              <!-- <div
                class="aNav"
                :class="{ active: isActive == '视频' }"
                @click="btn_nav($event)"
              >
                <router-link
                  :to="{ name: 'video', query: { keywords: search } }"
                  >视频</router-link
                >
              </div>
              <div
                class="aNav"
                :class="{ active: isActive == '部门' }"
                style="cursor: default"
              >
                <a style="color: rgb(203, 203, 203)">部门</a>
              </div>
              <div
                class="aNav"
                :class="{ active: isActive == '盟市' }"
                style="cursor: default"
              >
                <a style="color: rgb(203, 203, 203)">盟市</a>
              </div>
              <div
                class="aNav"
                :class="{ active: isActive == '自治区站群' }"
                style="margin-right: 0; cursor: default"
              >
                <a style="color: rgb(203, 203, 203)">自治区站群</a>
              </div> -->
            </div>
          </el-drawer>
          <div class="login">
            <div style="line-height:18px;">
              <a>欢迎访问内蒙古公共资源交易中心网站！</a>
            </div>
            <!-- <div class="meng">
              <div class="tag"></div>
              <div class="mengText">
                <a href="http://mgl.nmg.gov.cn/U_index.html" target="_blank"
                  >蒙文版</a
                >
              </div>
            </div> -->
            <!-- <div class="han">
              <div class="tag"></div>
              <div class="hanText">
                <a
                  href="https://zwfw.nmg.gov.cn/sso//sso/login?utype=0&amp;redirect=istrue&amp;client_id=LFWKGMPAY&amp;goto=http://www.nmg.gov.cn/"
                  target="_blank"
                  >登录/注册</a
                >
              </div>
            </div> -->
          </div>
        </div>
        <div class="logo">
          <a href="https://ggzyjy.nmg.gov.cn/" target="_blank">
            <!-- <img src="../../assets/img/logo20210202.png" alt="" /> -->
            <img src="../../assets/img/ggzy_logo.png" alt="" style="border-style: none;width:100%;height:auto">
          </a>
        </div>
        <div class="normalSearchBar">
          <div class="searchPosition fl">
            <!-- <el-cascader
              :placeholder="searchPosition"
              :show-all-levels="false"
              v-model="searchPosition"
              :options="options"
              @change="handleChange"
            ></el-cascader> -->
            <el-dropdown trigger="click" @command="changeSiteID">
              <span class="el-dropdown-link">
                {{ searchPosition }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item disabled>全平台</el-dropdown-item>
                <el-dropdown-item command="all">自治区本级</el-dropdown-item>
                <el-dropdown-item divided disabled>本站</el-dropdown-item>
                <el-dropdown-item command="nmg"
                  >内蒙古自治区公共资源交易中心</el-dropdown-item
                >
                <el-dropdown-item divided disabled>部门</el-dropdown-item>
                <el-dropdown-item v-for="(item, index) in sites" :key="index"
                  ><a
                    class="aCityLink"
                    :href="item.indexLogHref+
                        '/nmg_dept_search/#/Door?keywords=&siteTag=1&siteid=' +
                        item.siteId"
                    target="_blank"
                    style="color: inherit"
                    v-html="item.titleName.substring(3,item.titleName.length)"></a
                  ></el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div>
            <input
              type="text"
              name=""
              placeholder="请输入关键字查询"
              v-model="search"
              class="searchInput"
              @input="changeKey"
              @keyup.enter="btn_seach"
              maxlength="50"
            />
            <input type="button" value="搜索" @click="btn_seach" />
          </div>
          <div class="clear"></div>
        </div>
        <div class="select">
          <div class="select_sort">
            <select name="" id="" v-model="sort">
              <option value="" style="display: none">排序</option>
              <option value="1">按相关度排序</option>
              <option value="2">按时间排序</option>
            </select>
            <i></i>
          </div>
          <div class="select_position">
            <select name="" id="" v-model="position">
              <option value="" style="display: none">搜索位置</option>
              <option value="0">全文</option>
              <option value="1">标题</option>
            </select>
            <i></i>
          </div>
          <div class="select_date">
            <select name="" id="" v-model="date">
              <option value="" style="display: none">时间</option>
              <option value="9">时间不限</option>
              <option value="1">最近一周</option>
              <option value="2">最近一月</option>
              <option value="3">最近一年</option>
            </select>
            <i></i>
          </div>
        </div>
        <div class="total">
          相关结果约<span>{{ total }}</span
          >个
        </div>
      </div>
      <div class="main">
        <router-view
          ref="child"
          v-if="update"
          @rfunc="getSearchKey"
          @rhighSearch="getHighSearch"
          @rIsActice="getIsActice"
          @fGetTotal="getTotal"
          :fSort="sort"
          :fPosition="position"
          :fDate="date"
          :cSiteID="siteID"
        ></router-view>
      </div>
      <div class="clear"></div>
      <div class="footer">
        <v-footer></v-footer>
      </div>
    </div>
  </div>
</template>

<script>
import vFooter from "../footer";

export default {
  name: "App",
  components: {
    vFooter,
  },
  props: {},
  data() {
    return {
      sites: [],
      siteID: "39",
      total: 0,
      mobile: false,
      drawer: false,
      direction: "ltr",
      // input是否获取焦点
      isOnFocus: false,
      // 搜索关键字
      search: "",
      // 搜索栏目
      searchTag: "all",
      // 局部刷新子组件
      update: true,
      // 搜索提示
      tips: [],
      // 当前导航页面
      isActive: "门户网站",
      // 排序
      sort: "",
      // 搜索位置
      position: "",
      // 时间
      date: "",
      // 选择搜索位置
      selectPosition: false,
      // 搜索位置
      searchPosition: "本站",
      // 热搜词
      hotwords:[]
    };
  },
  watch: {
    // isActive: {
    //   handler() {
    //     if (
    //       this.search == "" ||
    //       this.search == " " ||
    //       this.search == undefined
    //     ) {
    //       this.$confirm("搜索内容不能为空", "提示", {
    //         confirmButtonText: "确定",
    //         cancelButtonText: "取消",
    //         type: "warning",
    //       }); //用catch来捕获错误消息
    //       console.log("闪屏？");
    //     }
    //   },
    // },
  },
  computed: {
    // 从vuex中获取搜索记录
    Histoty() {
      return this.$store.state.searchHistory;
    },
    // 从vuex中获取search的值
    StoreSearch() {
      return this.$store.state.search;
    },
    str() {
      return { str: this.search };
    },

    // 从vuex中获取searchTag的值
    // StoreSearchTag() {
    //   return this.$store.state.searchTag;
    // },
  },
  methods: {
    // 获取站点链接
    async getSites() {
      const { data: res } = await this.$http.get("/nmsearch/openSearch/getSites");
      if (res.state == 200) {
        this.sites = res.data;
      }
    },
    changeSiteID(command) {
      if (command == "all") {
        this.searchPosition = "全自治区";
        this.siteID = 0;
      }
      if (command == "nmg") {
        this.searchPosition = "本站";
        this.siteID = 39;
      }
      console.log(this.siteID);
    },
    // 切换搜索站点
    changePosition(position, siteID) {
      this.searchPosition = position;
      this.siteID = siteID;
      this.selectPosition = false;
    },
    // 点击高级搜索
    btn_highSearch() {
      this.$refs.child.btn_highSearch();
    },
    // 点击政策文件搜索
    btn_policySearch() {
      this.$refs.child.btn_policySearch();
    },
    // 点击导航
    btn_nav(e) {
      this.isActive = e.target.innerHTML;
      this.search = this.StoreSearch;
      this.drawer = false;
    },
    // 获取提示
    async getTip() {
      let params = this.$qs.stringify({
        params: this.str,
      })
      const { data: res } = await this.$http.get(
        "/nmsearch/trssearch/suggest.do?"+params,
        // {
        //   params: this.str,
        // }
      );

      if (res.code == 200) {
        this.tips = res.result;
      }
    },
    // 点击提示
    click_tip(e) {
      this.search = e.target.innerHTML.trim();
      this.btn_seach();
    },
    // 当前选中nav
    handleSelect(key, keypath) {
      this.activeIndex = key;
      this.searchTag = this.StoreSearchTag;
      // console.log(this.activeIndex);
    },

    // 判断input是否处于焦点状态
    inputFocus(e) {
      if (
        e.target.className == "searchInput" ||
        e.target.className == "title" ||
        e.target.className == "aNew" ||
        e.target.className == "link"
      ) {
        this.getTip();
        // console.log("input获取焦点");
        this.isOnFocus = true;
      } else {
        // console.log("input失去焦点");
        this.tips = [];
        this.isOnFocus = false;
      }
    },

    //当在搜索框中输入,将输入框中的值传给vuex
    changeKey() {
      // this.$store.commit("getSearchWord", this.search);
      this.getTip();
    },
    // 点击搜索按钮
    btn_seach() {
      // if(this.search != ""){
      //   this.search=this.search.replace(/\s+/g,'');
      // }
      // console.log("关键词："+this.search)
      // if (this.search.indexOf(" ")>0){
      //   this.search=this.search.replace(/\s+/g,'');
      // }
      if(this.search){
        this.search=this.search.replace(/\s+/g,'');
      }
      if (this.search == "" || this.search == undefined) {
        this.$confirm("搜索内容不能为空", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: "true",
        }); //用catch来捕获错误消息
      } else {
        // 点击搜索按钮后将关键字传给vuex
        this.$store.commit("getSearchWord", this.search);
        // 在点击搜索按钮后调用当前子组件中的获取数据的方法
        // this.$refs.child.getDataList();

        // 记录搜索记录
        this.$store.commit("getSearchHistory", this.search);
        // 局部刷新子组件
        this.update = false;
        this.$nextTick(() => {
          this.update = true;
        });
      }

      // this.$router.go(0);
      // console.log(this.searchTag);
    },

    // 获取侧边栏其它领导传来的领导名字
    getSearchKey(item) {
      // console.log(leader);
      this.search = item;
      // console.log(this.search);
      this.btn_seach();
    },

    // 获取总数
    getTotal(num) {
      this.total = num;
    },

    getHighSearch(highSearch) {
      this.search = highSearch;
      this.$store.commit("getSearchWord", highSearch);
    },
    getIsActice(isActive) {
      this.isActive = isActive;
      // console.log(this.isActive);
    },
    // 获取热搜词
    // 获取搜索热点
    async getHotwords() {
      const { data: res } = await this.$http.get(
        "/nmsearch/trssearch/gethotSearch.do",
        {
          params: { siteId: 39 },
        }
      );
      if (res.code == 200) {
        this.hotwords = res.result;
      }
      // console.log("hotwords:"+this.hotwords);
    },
    // 点击搜索热词
    // btn_hotWord(e) {
    //   this.search = e.target.innerHTML;
    //   this.btn_seach();
    // },
    btn_hotWord(e) {
      this.search = e;
      this.btn_seach();
    },
  },
  created() {
    // 每次刷新页面都重新指向到门户页面
    // this.$router.push("Door");
    // 将从vuex中获取到的search的值赋值给本页面的search
    this.getIsActice();
    this.getSites();
    this.getHotwords();
    this.search = this.StoreSearch;
    window.addEventListener("click", this.inputFocus);
  },
  mounted() {
    // if (
    //   this.search === "" ||
    //   this.search === " " ||
    //   this.search === undefined
    // ) {
    //   this.$confirm("搜索内容不能为空", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //     center: "true",
    //   }); //用catch来捕获错误消息
    // }

    // 初始化时显示或隐藏移动端
    if (document.body.clientWidth < 751) {
      this.mobile = true;
    }
    if (document.body.clientWidth >= 751) {
      this.mobile = false;
    }
    // 监听浏览器宽度变化控制展示隐藏移动端
    window.onresize = () => {
      if (document.body.clientWidth < 751) {
        this.mobile = true;
      }
      if (document.body.clientWidth >= 751) {
        this.mobile = false;
      }
    };
  },
  destroyed() {
    window.removeEventListener("click", this.inputFocus);
  },
};

// window.onkeypress = (event) => {
//     if(event.keyCode == 32) event.returnValue = false
// }
</script>

<style lang='less' scoped>
.clear {
  clear: both;
}
@media screen and (min-width: 751px) {
  .normal {
    .header {
      height: 300px;
      min-width: 1300px;
      background-image: url(../../assets/img/normal_search/ggzy_bg.png);
      background-size: 100% 100%;
      // background: no-repeat;
      .top_row1 {
        padding-top: 80px;
        height: 85px;
        width: 1281px;
        // width: 1250px;
        margin: 0 auto;
        .logo {
          width: 600px;
          // height: 100px;
          // margin-right: 40px;
          float: left;
          a {
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .selectPositionArea {
          width: 100%;
          height: 320px;
          font-size: 16px;
          line-height: 46px;
          color: #333;
          .searchAll{
            div.qpt{
              font-weight: bold;
            }
          }
          .searchLocal{
            div.bz{
              font-weight: bold;
              span{
                margin-left: 16px;
              }
            }
          }
          .searchCity{
            div.bm{
              font-weight: bold;
              span{
                margin-left: 16px;
              }
            }
          }
          .aPosition {
            a {
              color: #666;
            }
          }
          span {
            cursor: pointer;
            color: #666;
          }
          .active_position {
            // padding-left: 5px;
            // padding-right: 5px;
            background-color: rgb(1, 82, 147);
            color: #ffffff;
            // padding: 10px;
            padding: 0 10px;
            padding-bottom: 10px;
            padding-top: 8px;
          }
        }

        .normalSearchBar {
          width: 475px;
          height: 56px;
          float: left;
          margin-left: 60px;
          // top: 40%;
          position: relative;
          transform: translateY(20%);
          z-index: 999;
          .searchPosition {
            height: 44px;
            width: 80px;
            font-size: 16px;
            line-height: 45px;
            padding-left: 15px;
            padding-right: 25px;
            margin-right: 5px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            background-image: url("../../assets/img/normal_search/searchPosition_bg2.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            border-radius: 5px;
            cursor: pointer;
          }
          .hotWords {
            margin-top: 10px;
            margin-left: 20px;
            color: #fff;
            span {
              color: #fff;
              margin-right: 20px;
              cursor: pointer;
            }
            z-index: -1;
          }
          .showList {
            margin-top: -20px;
            margin-left: 124px;
            // margin-left: px;
            position: absolute;
            width: 350px;
            padding-top: 32px;
            // height: 600px;
            // border: 1px solid rgb(153, 153, 153);
            background-color: #ffffff;
            box-shadow: 2px 2px 2px rgb(153, 153, 153);
            z-index: -999;
            float: left;
            .row {
              width: 320px;
              height: 36px;
              padding-left: 25px;
              line-height: 36px;
              cursor: pointer;
            }
            .row:hover {
              background-color: rgb(249, 249, 249);
            }
            .row2 {
              width: 350px;
              height: 50px;
              padding-top: 10px;
              padding-left: 25px;
              line-height: 50px;
              cursor: pointer;
              .tag {
                height: 20px;
                width: 20px;
                margin-right: 10px;
                img {
                  height: 100%;
                  width: 100%;
                }
              }
              span {
                margin-left: 5px;
                color: rgb(0, 151, 136);
              }
            }
            .row2:hover {
              background-color: rgb(249, 249, 249);
            }
          }
        }
        .highArea {
          width: 100px;
          height: 20px;
          margin-left: 20px;
          // float: left;
          transform: translateY(80%);
          font-size: 16px;
          .row1 {
            height: 20px;
            width: 100px;
            margin-bottom: 10px;
            color: rgb(255, 255, 255);
            cursor: pointer;
            span {
              border-bottom: 1px solid rgb(255, 255, 255);
            }
            i {
              display: inline-block;
              width: 12px;
              height: 6px;
              background-image: url(../../assets/img/normal_search/highSearch3.png);
              background-size: 100% 100%;
              background-repeat: no-repeat;
              transform: translateY(-10%);
              margin-left: 10px;
            }
          }
          .row2 {
            height: 20px;
            width: 125px;
            cursor: pointer;

            i {
              display: inline-block;
              width: 17px;
              height: 14px;
              background-image: url(../../assets/img/normal_search/policy.png);
              background-size: 100% 100%;
              background-repeat: no-repeat;
              transform: translateY(10%);
              margin-right: 10px;
            }
          }
        }
        input {
          box-sizing: border-box;
          font-size: 16px;
          float: left;
        }

        input[type="text"] {
          width: 350px;
          height: 44px;
          border: none;
          outline: none;
          border-radius: 5px;
          padding-left: 15px;
          padding-right: 116px;
          background-image: url(../../assets/img/normal_search/input_search4.png);
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }

        input[type="button"] {
          font-size: 20px;
          width: 80px;
          height: 44px;
          margin-left: -80px;
          position: absolute;
          border-radius: 5px;
          border: none;
          outline: none;
          cursor: pointer;
          color: #ffffff;
          background-color: rgb(1, 82, 147);
          // background-image: url(../../assets/img/normal_search/input_btn.png);
          // background-size: 100% 100% no-repeat;
          appearance: none;
          -moz-appearance: none;
          -webkit-appearance: none;
        }
      }
    }
    .nav {
      // min-width: 1300px;
      width:100%;
      margin-top: -50px;
      height: 50px;
      background: rgb(1, 82, 147);
      margin-bottom: 30px;
      border-radius: 5px;

      .navs {
        width: 1280px;
        height: 60px;
        margin: 0 auto;
        .aNav {
          // width: 50px;
          // padding-top: 17px;
          text-align: center;
          padding-left: 28px;
          padding-right: 28px;
          // margin-right: 20px;
          height: 50px;
          float: left;
          color: #ffffff;
          font-size: 16px;
          line-height: 50px;
          position: relative;
          z-index: 0;
          a {
            display: inline-block;
            height: 50px;
            color: #ffffff;
            text-decoration: none;
          }
          .sanjiao{
            display: none;
            position: absolute;
            bottom: -8px;
            left: 50%;
            margin-left: -6px;
            display: none;
          }
          .huawen{
            display: none;
            position: absolute;
            top: 0;
            left: 50%;
            margin-left: -41px;
            z-index: -1;
          }
          router-link {
            height: 50px;
          }
        }
        .active {
          font-weight: bold;
          // background-color: rgb(64, 141, 204);
          border-bottom: 3px solid #fece32;
          box-sizing: border-box;
          background: url(../../assets/img/bluebg.png);
          background-size: 100% 100%;
          .sanjiao{
            display:block;
          }
          .huawen{
            display:block;
          }
        }
      }
    }
    .main {
      // width: 1200px;
      // width:1235px;
      min-height: 400px;
      margin: auto;
    }
    .footer {
      position: relative;
      width: 100%;
      margin-top: 40px;
      bottom: 0;
    }
  
  }

  
}

  

// 移动端样式
@media screen and (max-width: 750px) {
  @w: 7.5vw;
  @h: 10vh;
  .normal {
    display: none;
    // .header {
    //   width: 750px;
    //   height: 420px;
    //   background-image: url(../../assets/img/normal_search/header_bg.png);
    //   background-size: 100% 100%;
    // }
  }
  .mobile {
    width: 750 / @w;
    // height: 100px;
    display: block;
    // background-color: red;
    .topBar {
      width: 100%;
      height: 500 / @w;
      background-image: url("../../assets/img/ggzy_bg.png");
      background-size: auto 100%;
      background-repeat: no-repeat;
      margin-bottom: 20 / @w;
      .loginArea {
        width: 100%;
        height: 67 / @w;
        background-color: rgb(1, 82, 147);
        .menu {
          float: left;
          height: 40 / @w;
          width: 40 / @w;
          background-image: url("../../assets/img/mobile/menu.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
          margin-top: 15 / @w;
          margin-left: 30 / @w;
        }
        /deep/.el-drawer__body {
          background-color: rgb(1, 82, 147);
        }
        .navs {
          width: 100%;
          font-size: 30 / @w;
          .aNav {
            text-align: center;

            a {
              color: #ffffff;
              display: inline-block;
              width: 100%;
              height: 70 / @w;
              line-height: 80 / @w;
            }
          }

          .active {
            background-color: rgb(64, 141, 204);
            font-weight: bold;
          }
        }

        .login {
          float: right;
          width: 440 / @w;
          height: 40 / @w;
          margin-top: 15 / @w;
          a {
            text-decoration: none;
            font-size: 24 / @w;
            color: #ffffff;
          }
          .meng {
            width: 130 / @w;
            height: 40 / @w;
            float: left;
            .tag {
              float: left;
              width: 23 / @w;
              height: 40 / @w;
              background-image: url("../../assets/img/mobile/tag_meng.png");
              background-size: 100% 100%;
              background-repeat: no-repeat;
            }
            .mengText {
              height: 40 / @w;
              float: left;
              font-size: 24 / @w;
              color: #ffffff;
              line-height: 40 / @w;
              margin-left: 20 / @w;
            }
          }
          .han {
            width: 180 / @w;
            height: 40 / @w;
            float: left;
            margin-left: 30 / @w;
            .tag {
              float: left;
              margin-top: 5 / @w;
              width: 30 / @w;
              height: 30 / @w;
              background-image: url("../../assets/img/mobile/tag_han.png");
              background-size: 100% 100%;
              background-repeat: no-repeat;
            }
            .hanText {
              height: 40 / @h;
              float: left;
              font-size: 24 / @w;
              color: #ffffff;
              line-height: 40 / @w;
              margin-left: 20 / @w;
            }
          }
        }
      }
      .logo {
        width: 510 / @w;
        height: 110 / @w;
        margin: 0 auto;
        margin-top: 35 / @w;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .normalSearchBar {
        // width: 90%;
        width: 650 / @w;
        height: 70 / @w;
        margin: 0 auto;
        margin-top: 40 / @w;
        border: 1px solid rgb(1, 82, 147);
        border-radius: 8 / @w;
        .searchPosition {
          height: 70 / @w;
          width: 150 / @w;
          padding-left: 20px;
          text-align: center;
          line-height: 70 / @w;
          position: absolute;

          /deep/.el-cascader {
            width: 210 / @w;
            height: 70 / @w;

            .el-input__inner {
              height: 60 / @w;
              border: none;
            }
            .el-input__inner:hover {
              border: none;
            }
          }
        }
        input {
          box-sizing: border-box;
          // font-size: 16 / @w;
          float: left;
        }

        input[type="text"] {
          width: 650 / @w;
          height: 70 / @w;
          border: none;
          outline: none;
          border-radius: 5 / @w;
          padding-left: 220 / @w;
          padding-right: 116 / @w;
          // background-image: url(../../assets/img/normal_search/input_search3.png);
          background-size: 100% 100%;
          background-repeat: no-repeat;
          // margin-left: 80px;
        }

        input[type="button"] {
          font-size: 20 / @w;
          width: 100 / @w;
          height: 70 / @w;
          margin-left: -100 / @w;
          position: absolute;
          border-radius: 5 / @w;
          border: none;
          outline: none;
          cursor: pointer;
          color: #ffffff;
          background-color: rgb(0, 91, 154);
          // background-image: url(../../assets/img/normal_search/input_btn.png);
          // background-size: 100% 100% no-repeat;
          appearance: none;
          -moz-appearance: none;
          -webkit-appearance: none;
        }
      }
      .select {
        width: 690 / @w;
        height: 55 / @w;
        margin: 0 auto;
        margin-top: 50 / @w;
        .select_sort {
          width: 182 / @w;
          height: 40 / @w;
          margin-right: 20 / @w;
          float: left;
          select {
            width: 182 / @w;
            height: 40 / @w;
            // font-size: 26 / @w;
            text-align: center;
            -webkit-appearance: none;
            background-color: #ffffff;
          }
          i {
            display: inline-block;
            height: 20 / @w;
            width: 20 / @w;
            background-image: url("../../assets/img/select_down.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            position: absolute;
            margin-top: 10 / @w;
            margin-left: -30 / @w;
          }
        }
        .select_position {
          width: 300 / @w;
          height: 40 / @w;
          margin-right: 18 / @w;
          float: left;
          select {
            width: 300 / @w;
            height: 40 / @w;
            // font-size: 26 / @w;
            text-align: center;
            -webkit-appearance: none;
            background-color: #ffffff;
          }
          i {
            display: inline-block;
            height: 20 / @w;
            width: 20 / @w;
            background-image: url("../../assets/img/select_down.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            position: absolute;
            margin-top: 10 / @w;
            margin-left: -30 / @w;
          }
        }
        .select_date {
          width: 170 / @w;
          height: 40 / @w;
          float: left;
          select {
            width: 170 / @w;
            height: 40 / @w;
            // font-size: 26 / @w;
            text-align: center;
            -webkit-appearance: none;
            background-color: #ffffff;
          }
          i {
            display: inline-block;
            height: 20 / @w;
            width: 20 / @w;
            background-image: url("../../assets/img/select_down.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            position: absolute;
            margin-top: 10 / @w;
            margin-left: -30 / @w;
          }
        }
      }

      .total {
        width: 270 / @w;
        height: 30 / @w;
        margin: 0 auto;
        margin-top: 20 / @w;
        // font-size: 26 / @w;
        line-height: 30 / @w;
        // color: rgb(102, 102, 102);
        color:#fff;
        span {
          // color: rgb(1, 82, 147);
          color:red;
        }
      }
    }
    .main {
      width: 100%;
      min-height: 300 / @w;
      margin: auto;
    }
  }
}
</style>
<style>
  #nmgsitechange .el-dialog{
    border-radius: 10px;
    overflow: hidden;
    /* border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px; */
  }
  #nmgsitechange .flomodel{
    position: absolute;
    bottom: -60px;
    right: -60px;
  }
  #nmgsitechange .el-dialog .el-dialog__header{
    height: 50px;
    background: #f4f4f4;
    padding: 0;
  }
  #nmgsitechange .el-dialog .el-dialog__title{
    line-height: 50px;
    font-size: 16px;
    color: #333;
    margin-left: 30px;
  }
  #nmgsitechange .el-dialog__headerbtn{
    top: 16px;
    right: 40px;
  }
  #nmgsitechange .el-icon-close:before{
    content:url(../../assets/img/closemodel23.png)
  }
  #nmgsitechange .el-dialog__body{
    padding: 30px 30px;
    position: relative;
  }

</style>